// https://stackoverflow.com/questions/44065854/make-button-group-look-like-radio-button

import React, { Component } from 'react'

import marker_all from '../images/pin-all.png'
import marker_5g from '../images/pin-5g.png'
import marker_l5g from '../images/pin-l5g.png'
import marker_lab from '../images/pin-lab.png'

class TypeButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeOption: this.props.options[0],
    }
  }

  /**
   * 選択された事例ボタンの活性／非活性化
   * @param  {String} activeOption 事例文字列
   */
  updateActiveOption = (activeOption) => {
    this.setState({
      activeOption,
    })
  }
  
  render() {
    return (
      <div
        style={{
        }}
      >

        {this.props.options.map((option, idx) => {
          let label = ''
          let marker = ''
          switch (option) {
            case 'ALL':
              label = '全事例'
              marker = marker_all
              break
            case '5G':
              label = '5G事例'
              marker = marker_5g
              break
            case 'LAB':
              label = 'ラボ・開発環境'
              marker = marker_lab
              break
            case 'L5G':
              label = 'ローカル5G事例'
              marker = marker_l5g
              break
            default:
              break
          }
          return (
            <button
            onClick={() => {
              this.props.onChange(option)
              this.updateActiveOption(option)
            }}
            style={{
              width: 150,
              borderWidth: 1,
              height: 50,
              color: this.state.activeOption === option ? 'red' : 'black',
            }}
            className={`type ${option} ${this.state.activeOption === option ? 'active' : 'inactive'}`}
            key={idx}
          >
            <span>{label}</span>
            <img src={`${marker}`} alt="marker" />
          </button>
          )
        })}
      </div>
    )
  }
}

export default TypeButton
